/**
 * Données de repli local pour les pages d'aide à la décision, utilisées
 * uniquement si l'API est injoignable (l'API sert ces données en temps normal).
 * Valeurs déterministes pour des rendus reproductibles.
 */

export const ZONES = [
  { id: 'DKR-01', nom: 'Dakar-Plateau' },
  { id: 'DKR-02', nom: 'Grand Dakar' },
  { id: 'DKR-03', nom: 'Parcelles Assainies' },
  { id: 'PIK-01', nom: 'Pikine' },
  { id: 'GUE-01', nom: 'Guédiawaye' },
  { id: 'RUF-01', nom: 'Rufisque' },
  { id: 'DKR-04', nom: 'Médina' },
  { id: 'DKR-05', nom: 'Yoff' },
];

/* 4 · Profilage comportemental des zones (indicateurs bandicoot) */
export const profiling = {
  zones: [
    { zone_id: 'DKR-01', nom: 'Dakar-Plateau', type: 'Transit / affaires', entropy_places: 1.94, radius_km: 8.1, pct_home: 0.39, active_days: 23.7, places: 14, users: 10419 },
    { zone_id: 'DKR-03', nom: 'Parcelles Assainies', type: 'Mixte', entropy_places: 1.76, radius_km: 8.1, pct_home: 0.49, active_days: 22.9, places: 13, users: 12261 },
    { zone_id: 'GUE-01', nom: 'Guédiawaye', type: 'Résidentielle', entropy_places: 1.72, radius_km: 8.0, pct_home: 0.5, active_days: 22.4, places: 12, users: 6801 },
    { zone_id: 'PIK-01', nom: 'Pikine', type: 'Mixte', entropy_places: 1.69, radius_km: 8.0, pct_home: 0.49, active_days: 22.1, places: 12, users: 6516 },
  ],
  modele: 'indicateurs bandicoot',
};

/* 7 · Indice d'accessibilité territoriale (score composite 0-100) */
export const accessibility = {
  zones: [
    { zone_id: 'DKR-01', nom: 'Dakar-Plateau', score: 88, offre: 92, temps_acces: 90, equite: 82 },
    { zone_id: 'DKR-04', nom: 'Médina', score: 79, offre: 80, temps_acces: 82, equite: 75 },
    { zone_id: 'DKR-02', nom: 'Grand Dakar', score: 71, offre: 70, temps_acces: 74, equite: 69 },
    { zone_id: 'DKR-05', nom: 'Yoff', score: 64, offre: 60, temps_acces: 68, equite: 64 },
    { zone_id: 'PIK-01', nom: 'Pikine', score: 47, offre: 42, temps_acces: 48, equite: 51 },
    { zone_id: 'GUE-01', nom: 'Guédiawaye', score: 43, offre: 38, temps_acces: 45, equite: 46 },
    { zone_id: 'DKR-03', nom: 'Parcelles Assainies', score: 41, offre: 36, temps_acces: 44, equite: 43 },
    { zone_id: 'RUF-01', nom: 'Rufisque', score: 33, offre: 28, temps_acces: 31, equite: 40 },
  ],
  modele: 'Indice composite (offre · temps d\'accès · équité)',
};

/* 3 · Analyse des événements spéciaux (normal vs grand rassemblement) */
export const events = {
  evenement: 'Grand Magal de Touba',
  zone_focus: 'Axe Dakar → Touba (sortie est)',
  multiplicateur_pic: 3.4,
  series: [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
  ].map((h) => {
    const normal = [120, 90, 70, 60, 90, 240, 620, 1080, 1240, 1080, 980, 1010, 1120, 1060, 990, 1020, 1180, 1360, 1240, 880, 560, 380, 250, 160][h];
    const event = Math.round(normal * [1, 1, 1.1, 1.3, 1.8, 2.6, 3.1, 3.4, 3.2, 2.6, 2.1, 1.9, 1.8, 1.7, 1.7, 1.9, 2.3, 2.8, 3.0, 2.4, 1.8, 1.5, 1.3, 1.1][h]);
    return { heure: `${String(h).padStart(2, '0')}:00`, normal, evenement: event };
  }),
  recommandations: [
    'Pré-positionner 12 bus Dakar Dem Dikk sur l\'axe est dès 05h00.',
    'Renforcer le TER (rotations +40 %) entre 06h et 10h.',
    'Activer la signalétique de délestage VDN → autoroute à péage.',
  ],
  modele: 'Comparatif historique des rassemblements',
};

/* 10 · Prévision de la demande événementielle */
export const eventForecast = {
  evenements: [
    { nom: 'Tabaski (Aïd el-Kébir)', date: '2026-06-16', uplift: 2.8, zones: ['Pikine', 'Guédiawaye', 'Rufisque'], confiance: 0.86 },
    { nom: 'Grand Magal de Touba', date: '2026-08-04', uplift: 3.4, zones: ['Plateau', 'Gare routière', 'Axe est'], confiance: 0.91 },
    { nom: 'Gamou de Tivaouane', date: '2026-09-25', uplift: 2.1, zones: ['Médina', 'Axe nord'], confiance: 0.79 },
  ],
  modele: 'Modèle saisonnier (historique des rassemblements)',
};

/* 5 · Optimiseur de lignes & de flottes */
export const optimizer = {
  recommandations: [
    { ligne: 'Nouvelle ligne A', trace: 'Guédiawaye → Plateau', demande_couverte: 12400, frequence_min: 8, gain: 'Désert desservi', priorite: 'haute' },
    { ligne: 'Renfort ligne BRT-1', trace: 'Pikine → Plateau', demande_couverte: 9800, frequence_min: 6, gain: '-22 % attente', priorite: 'haute' },
    { ligne: 'Nouvelle ligne B', trace: 'Rufisque → Parcelles', demande_couverte: 5200, frequence_min: 12, gain: 'Liaison banlieue', priorite: 'moyenne' },
    { ligne: 'Réaffectation flotte', trace: 'Yoff → Médina', demande_couverte: 3100, frequence_min: 15, gain: 'Optimisation creux', priorite: 'basse' },
  ],
  couverture_actuelle: 63,
  couverture_optimisee: 81,
  modele: 'Optimisation de la couverture de la demande',
};

/* 9 · API ouverte & export open-data */
export const openData = {
  base_url: 'https://smartmobility.duckdns.org/api/v1',
  ressources: [
    { nom: 'Flux Origine-Destination', endpoint: '/flows/od/', methode: 'GET', formats: ['JSON', 'GeoJSON'], desc: 'Matrice OD entre arrondissements.' },
    { nom: 'Prévisions de flux', endpoint: '/predictions/', methode: 'GET', formats: ['JSON'], desc: 'Flux horaires prévus (24 h).' },
    { nom: 'Déserts de mobilité', endpoint: '/mobility-deserts/', methode: 'GET', formats: ['JSON'], desc: 'Zones mal desservies + scores.' },
    { nom: 'Anomalies', endpoint: '/anomalies/', methode: 'GET', formats: ['JSON'], desc: 'Incidents et pics détectés.' },
    { nom: 'Affluence', endpoint: '/crowding/', methode: 'GET', formats: ['JSON'], desc: 'Taux d\'occupation par zone.' },
    { nom: 'État du service', endpoint: '/health/', methode: 'GET', formats: ['JSON'], desc: 'Disponibilité de l\'API.' },
  ],
  futur: ['Export GTFS', 'Tuiles vectorielles', 'Webhooks temps réel'],
};

/* 8 · Jumeau numérique — calcul de simulation (côté client, déterministe) */
export function simulate({ newLine = false, frequency = 10, closeAxis = false }) {
  // Calcul de simulation : impact relatif sur temps de trajet, couverture, congestion.
  let temps = 38; // min, baseline
  let couverture = 63; // %
  let congestion = 72; // index
  if (newLine) { temps -= 6; couverture += 11; congestion -= 8; }
  temps -= Math.round((10 - Math.min(frequency, 20)) * 0.4);
  if (closeAxis) { temps += 9; congestion += 14; couverture -= 4; }
  return {
    temps_trajet_min: Math.max(12, temps),
    couverture_pct: Math.max(0, Math.min(100, couverture)),
    congestion_index: Math.max(0, Math.min(100, congestion)),
  };
}
